import { useUserRoles } from "./RolesProvider";
import { Navigate } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import type { MenuKeys } from "@repo/server-api/types";
import type { RuleFactoryType } from "@repo/server-api/types";
import React from "react";

type ProtectedRouteProps = {
	children: React.ReactNode;
	menuKey: MenuKeys;
	ruleFactory: RuleFactoryType;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
	children,
	menuKey,
	ruleFactory,
}) => {
	const roles = useUserRoles();

	// Wenn roles.roles leer ist, sind die Rollen noch am Laden
	// Zeige Loader statt sofort umzuleiten
	if (roles.roles.length === 0) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
				<CircularProgress />
			</Box>
		);
	}

	// Prüfe Autorisierung mit bestehender RuleFactory Logik
	const isAuthorized = ruleFactory.allowedMenuItem(menuKey, roles.roles);

	// Leite zum Dashboard um wenn nicht autorisiert
	if (!isAuthorized) {
		return <Navigate to="/" replace />;
	}

	// Rendere Children wenn autorisiert
	return <>{children}</>;
};
